import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


// const routes = [{
//   path: '/index',
//   name: 'index',
//   component: () => import('../views/index.vue')
// }]
const routes = [
	{
		path: '/',
		redirect:{
			name: 'index',
		}
	},{
		path: '/index',
		name: 'index',
		noCache: false,
		keepAlive: true,
		component: () => import('@/views/index.vue')
	},
	{
		path: '/energy',
		name: 'energy',
		noCache: false,
		keepAlive: true,
		component: () => import('@/views/energy.vue'),
		meta: {
			title: '能耗管理',
		},
	},
	{
		path: '/operation',
		name: 'operation',
		noCache: false,
		keepAlive: true,
		component: () => import('@/views/operation.vue'),
		meta: {
			title: '运行管理',
		},
	},
	{
		path: '/building',
		name: 'building',
		noCache: false,
		keepAlive: true,
		component: () => import('@/views/building.vue'),
		meta: {
			title: '仓库管理',
		},
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login.vue'),
		meta: {
			title: '登录',
		},
	},
]
const router = new VueRouter({
	mode: "history",
	routes
})

/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default router
